"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.Link = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _gatsby = require("gatsby");
var _intl = require("@myci/intl");
var _utils = require("./utils");
var _IntlNavigationProvider = require("./IntlNavigationProvider");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["to", "locale"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Prepends locale to the `to` attribute according the current state of the app.
 */
var Link = exports.Link = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var to = _ref.to,
    locale = _ref.locale,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var intl = (0, _intl.useIntl)();
  var _useIntlNavigation = (0, _IntlNavigationProvider.useIntlNavigation)(),
    defaultLocale = _useIntlNavigation.defaultLocale;
  var resolvedLocale = (0, _utils.toUrlLocale)(locale || intl.locale);
  if ((0, _utils.isAddressProbablyInvalid)(to)) {
    console.warn('[gatsby-plugin-intl] You have used the Link that adds locale into URLs. But you used relative Link instead. This component is really meant only for the absolute paths.');
  }
  if (!to) return null;
  var resolvedTo = resolvedLocale === (0, _utils.toUrlLocale)(defaultLocale) ? to : "/" + resolvedLocale + to;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gatsby.Link, Object.assign({}, rest, {
    to: resolvedTo,
    ref: ref
  }));
});
Link.displayName = 'Link';
var _default = exports.default = Link;